import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { Images } from "../../assets/common";
import LinearBar from "./../../components/LinearBar";
import { useHistory } from "react-router-dom";
import "./index.scss";
import { kFormatter } from "../../constants/function";
import { useTranslation } from "react-i18next";
export default function LevelCard({
  title,
  path,
  icon,
  data,
  width,
  color,
  isAmount,
}) {
  const { t } = useTranslation("common");
  const history = useHistory();
  return (
    <Box className="__level_widget" sx={{ width: width ? width : "auto" }}>
      <Stack direction="row" justifyContent="space-between">
        <Stack direction="row" gap="10px">
          {icon && (icon.startsWith('http') || icon.startsWith('/images/')) ? (
            <img style={{ width: "20px" }} src={icon} alt="icon" />
          ) : (
            <Typography style={{ fontSize: "20px" }}>{icon}</Typography>
          )}
          <Typography>{title}</Typography>
        </Stack>
        {/* TODO:commented */}
        {/* {path ? (
          <img
            className="_cp"
            onClick={() => history.push(path)}
            src={Images.link}
            alt="link"
          />
        ) : null} */}
      </Stack>
      <Stack>
        <Typography className="faded ml_auto fs-30">
          {isAmount ? "USD" : ""}{" "}
          {data["count"] ? kFormatter(data["count"]) : 0}
        </Typography>
      </Stack>

      {title === "Views" ? null : (
        <>
          <LinearBar
            color={color}
            value={`${
              (data["count"] / data["upperLimit"]) * 100 > 100
                ? "100"
                : (data["count"] / data["upperLimit"]) * 100
            }%`}
          />
          <Stack
            direction="row"
            justifyContent="space-between"
            className="mt-5"
          >
            <Typography className="fs-12">
              {t("leaderBoard.level")} {data["level"] ? data["level"] : 0}
              {/* {console.log(data, "::Data::")} */}
            </Typography>
            {data["count"] < data["upperLimit"] ? (
              <Typography className="fs-12">{`+ ${
                isAmount 
                  ? (data["upperLimit"] - data["count"]).toFixed(2)
                  : Math.round(data["upperLimit"] - data["count"])
              } ${title} for Level ${data["level"] + 1}`}</Typography>
            ) : null}
          </Stack>
        </>
      )}
    </Box>
  );
}
